import { render, staticRenderFns } from "./PackagingWeightComponent.vue?vue&type=template&id=34dcacd0&"
import script from "./PackagingWeightComponent.vue?vue&type=script&lang=js&"
export * from "./PackagingWeightComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports